import { extend } from 'vee-validate';
import { required, email } from 'vee-validate/dist/rules';

extend("required", {
    ...required,
    message: "Ce champ est obligatoire."
});
  
extend("email", {
    ...email,
    message: "Veuillez saisir une adresse e-mail valide."
});

extend('password', {
    validate: value => {
        return /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/.test(value);
    },
    message: 'Le mot de passe saisi est invalide. Il doit contenir au moins 6 caractères (et au moins 1 chiffre, 1 majuscule et 1 minuscule).'
});

extend('confirmPassword', {
    params: ['target'],
    validate(value, { target }) {
      return value === target;
    },
    message: 'Les mots de passe saisis ne correspondent pas.'
});
